export default __webpack_public_path__ + "static/media/kmptc-fullview.3102c71c.jpg";